// extracted by mini-css-extract-plugin
export default {"boxes":"InfoBoxes_boxes__bLoGH","box":"InfoBoxes_box__Bqkof","box_section":"InfoBoxes_box_section__FYrCa","count":"InfoBoxes_count__UdQn4"};